import { render } from "./ShortResponsePreview.vue?vue&type=template&id=9cf66d1e&scoped=true"
import script from "./ShortResponsePreview.vue?vue&type=script&lang=js"
export * from "./ShortResponsePreview.vue?vue&type=script&lang=js"

import "./ShortResponsePreview.vue?vue&type=style&index=0&id=9cf66d1e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cf66d1e"]])

export default __exports__